import { Route, Switch } from 'react-router-dom';
import React, { useContext, useEffect } from 'react';

import VideoEditPage from 'story-media/video-editor/VideoEditPage';
import { CurrentCollectionContext } from '../collections/current-collection-context';
import EditStory from './edit-story';
import NewStory from './new';
import StoryDetail from './story-detail';
import StoryChatPage from './chats';
import TellAStorySuccess from './tell-a-story/Success';
import { useInitBookPages } from './book-pages-context';

const Stories = () => {
  const { resetCurrentCollection } = useContext(CurrentCollectionContext);
  // TODO add logic for showing on mobile
  const { refreshBookPages } = useInitBookPages();

  useEffect(() => resetCurrentCollection, [resetCurrentCollection]);

  return (
    <Switch>
      {/* <Route exact path="/stories/:currentFilter/:storyId/download" component={StoriesList} /> */}
      {/* <Route exact path="/stories/:currentFilter?" component={StoriesList} /> */}

      {/* <Route path="/tell_a_story/stories/new/:id" component={NewStory} />
      <Route path="/tell_a_story/story/:id/edit" component={EditStory} />
      <Route path="/tell_a_story/story/:id/chats/:meetingId" component={StoryChatPage} />
      <Route exact path="/tell_a_story/story/:id/:notificationSubjectId?" component={StoryDetail} />
      <Route exact path="/tell_a_story/story/:id/delete" component={StoryDetail} />
      <Route exact path="/tell_a_story/story/:id/shares" component={StoryDetail} />
      <Route path="/tell_a_story/story/:id/video/:videoId" component={VideoEditPage} />
      <Route path="/tell_a_story/story/:id" component={StoryDetail} /> */}

      <Route path="/(tell_a_story|stories)/new/:id" component={NewStory} />
      <Route path="/story/:id/edit" component={() => <EditStory refreshBookPages={refreshBookPages} />} />
      <Route path="/tell_a_story/story/:id/edit" component={() => <EditStory refreshBookPages={refreshBookPages} />} />
      <Route path="/tell_a_story/story/:id/success" component={TellAStorySuccess} />

      <Route path="/story/:id/chats/:meetingId" component={StoryChatPage} />
      {/* Book pages are fetched via refreshBookPages(id), which sets the story id
          that drives the polling SWR key in useInitBookPages. Previously that only
          ran from the Edit/Done click handler in StoryDetailHeaderNav, so landing
          directly on /story/:id (a hard refresh, or any link straight to a story)
          never triggered it — BookPagesSection's "Creating your preview" overlay,
          gated on state !== FINISHED, stayed up forever since state never left its
          initial null. Passing it through here too lets StoryDetail kick off the
          fetch itself on mount. */}
      <Route exact path="/story/:id/:notificationSubjectId?" render={props => <StoryDetail {...props} refreshBookPages={refreshBookPages} />} />
      <Route exact path="/story/:id/delete" render={props => <StoryDetail {...props} refreshBookPages={refreshBookPages} />} />
      <Route exact path="/tell_a_story/story/:id/delete" render={props => <StoryDetail {...props} refreshBookPages={refreshBookPages} />} />

      <Route exact path="/story/:id/shares" render={props => <StoryDetail {...props} refreshBookPages={refreshBookPages} />} />
      <Route path="/story/:id/video/:videoId" component={VideoEditPage} />
      <Route path="/tell_a_story/story/:id" render={props => <StoryDetail {...props} refreshBookPages={refreshBookPages} />} />
      <Route path="/story/:id" render={props => <StoryDetail {...props} refreshBookPages={refreshBookPages} />} />
    </Switch>
  );
};

export default Stories;
